import type { PurchaseTransaction } from '../types/purchaseTransaction';

export const purchaseTransactionRowKey = (txn: PurchaseTransaction): string =>
  `${txn.transaction_type}-${txn.id}`;

export interface PurchaseTransactionTotals {
  count: number;
  totalAmount: number;
  balance: number;
}

export const computePurchaseTransactionTotals = (
  rows: PurchaseTransaction[]
): PurchaseTransactionTotals => {
  let totalAmount = 0;
  let balance = 0;
  for (const txn of rows) {
    totalAmount += parseFloat(txn.total_amount) || 0;
    balance += parseFloat(txn.balance) || 0;
  }
  return {
    count: rows.length,
    totalAmount,
    balance,
  };
};
